import React from 'react';
import css from './Content.module.css';

const Content = (props) => (
	<div {...props} className={[css.Content, props.className].join(' ')}>
		{props.children}
	</div>
);
export default Content;
